import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { ShowCookieSettings } from '@teamfoster/sdk/cookie-ngrx';
import { MenuItem } from '@teamfoster/sdk/menu-ngrx';
import { SocialChannel } from 'src/app/social-media/models';
import { Storefront } from 'src/app/storefronts';
// import { test } from './loremData';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    standalone: false
})
export class FooterComponent {
  currentYear: number = new Date().getFullYear();
  maxListLengthPerColumn = 6;

  // Loremdata
  @Input() menu: MenuItem[] = [];
  @Input() socials: SocialChannel[] = [];
  @Input() metaList: MenuItem[] = [];
  @Input() storefront: Storefront | null = null;
  // testmenu = test as unknown as MenuItem[];

  constructor(private store: Store) {}

  getColumnClasses(itemCount: number = 0) {
    let colCountBig = Math.ceil(itemCount / this.maxListLengthPerColumn) * 2;
    colCountBig = colCountBig > 6 ? 6 : colCountBig;
    return `col-12 col-sm-${itemCount > this.maxListLengthPerColumn ? '12' : '6'} col-lg-${colCountBig}`;
  }

  getColumnClassesInside(itemCount: number = 0) {
    let colCountBig = 12 / Math.ceil(itemCount / this.maxListLengthPerColumn);
    colCountBig = colCountBig < 4 ? 4 : colCountBig;
    return `col-12 col-sm-${colCountBig} col-lg-${colCountBig}`;
  }

  get hasBigMenu() {
    return this.menu.filter(a => !(a.menuItems.length > this.maxListLengthPerColumn)).length % 2 === 1;
  }

  openCookie() {
    this.store.dispatch(ShowCookieSettings());
  }

  trackById(i: number, item: any) {
    return item['id'] || item['guid'];
  }
}
